import { createIllustration } from '@atlassian/jira-illustration/src/ui/index.tsx';
import ideasLight from '../../assets/ideas/ideas-light.svg';
import ideasDark from '../../assets/ideas/ideas-dark.svg';
import roadmapLight from '../../assets/roadmap/roadmap-light.svg';
import roadmapDark from '../../assets/roadmap/roadmap-dark.svg';
import deliveryLight from '../../assets/delivery/delivery-light.svg';
import deliveryDark from '../../assets/delivery/delivery-dark.svg';

export const ideasIllustration = createIllustration({
	srcLight: ideasLight,
	srcDark: ideasDark,
});

export const roadmapIllustration = createIllustration({
	srcLight: roadmapLight,
	srcDark: roadmapDark,
});

export const deliveryIllustration = createIllustration({
	srcLight: deliveryLight,
	srcDark: deliveryDark,
});
